export const COLLECTION_NAME = 'tooltipContent';
export const classNames = {
    POPOVER_CONTENT: "ql-tooltip-content",
    POPOVER_CONTENT_BLOCK: "ql-tooltip-block",
    LAUNCH_FORMAT: "ql-tooltip-launcher"
}

export const attributeNames = {
    POPOVER_LAUNCH_ID: "popoverLaunchId",
    POPOVER_LAUNCH_ID_DATA: 'data-popoverlaunchid',
    POPOVER_CONTENT_ID: "popoverContentId",
    POPOVER_CONTENT_ID_DATA: 'data-popovercontentid',
    IS_POPOVER_VISIBLE: "isPopoverVisible"
}
